import pagePermissions from '@/enums/pagePermissions';
import { PermissionMiddleware } from '@/router/Middleware/PermissionMiddleware';

const serviceRoutes = [
  {
    path: '/administration/access',
    name: 'access-management',
    component: () => import('../Pages/Service/Access/index.vue'),
    meta: { name: 'Управление доступом', ownerOnly: true },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../Pages/Service/Upload/index.vue'),
    meta: {
      name: 'Загрузка планировки',
    },
  },
  {
    path: '/plans',
    name: 'Plans',
    component: () => import('../Pages/Service/Plans/index.vue'),
    meta: {
      name: 'Планировки',
    },
  },
  {
    path: '/plans/:id',
    name: 'plans-show',
    component: () => import('../Pages/Service/Plans/id.vue'),
    meta: {
      name: 'Планировка',
    },
  },
  {
    path: '/furniture/:id',
    name: 'furniture-show',
    component: () => import('../Pages/Service/Furniture/id.vue'),
    meta: {
      name: 'Мебель',
    },
  },
  {
    path: '/apertures/:id',
    name: 'aperture-show',
    component: () => import('../Pages/Service/Apertures/id.vue'),
    meta: {
      name: 'Апертура',
    },
  },
  {
    path: '/moldings/:id',
    name: 'molding-show',
    component: () => import('../Pages/Service/Moldings/id.vue'),
    meta: {
      name: 'Молдинг',
    },
  },
  {
    path: '/materials/:id',
    name: 'material-show',
    component: () => import('../Pages/Service/UnrealMaterials/id.vue'),
    meta: {
      name: 'Материал',
    },
  },
  {
    path: '/design-files',
    name: 'design-files',
    component: () => import('../Pages/Service/DesignFile/index.vue'),
    meta: {
      name: 'Дизайн-документы',
    },
  },
  {
    path: '/guards/create',
    name: 'guard-create',
    component: () => import('../Pages/Service/Guards/id.vue'),
    meta: {
      name: 'Новая проверка планировки',
    },
  },
  {
    path: '/guards/:id',
    name: 'guard-show',
    component: () => import('../Pages/Service/Guards/id.vue'),
    meta: {
      name: 'Проверка планировки',
    },
  },
  {
    path: '/substances/branding/:id',
    name: 'branding-show',
    component: () => import('../Pages/Service/Substances/Branding/id.vue'),
    meta: {
      name: 'Брендинг',
    },
  },
  {
    path: '/neural_dataset_selection',
    name: 'DatasetSelectionPlans',
    component: () => import('../Pages/Service/DatasetSelectionPlans/index.vue'),
    meta: {
      name: 'Сбор датасета для обучения нейронки',
    },
  },
  {
    path: '/neural_dataset_selection/datasets/:dataset/get_to_work',
    name: 'GetToWork',
    component: () => import('../Components/Service/DatasetSelectionPlans/GetToWork.vue'),
    meta: {
      name: 'Сбор датасета для обучения нейронки',
    },
  },
  {
    path: '/library/furniture/svg',
    name: 'library-furniture-svg',
    component: () => import('../Pages/Service/SvgEditorFurniture/index.vue'),
    meta: {
      name: 'SVG-фурнитура',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/furniture/unreal/objects',
    name: 'library-furniture-objects',
    component: () => import('../Pages/Service/Furniture/index.vue'),
    meta: {
      name: 'Мебель — объекты',
      section: 'objects',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/furniture/unreal/tags',
    name: 'library-furniture-tags',
    component: () => import('../Pages/Service/Furniture/index.vue'),
    meta: {
      name: 'Мебель — теги',
      section: 'tags',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/furniture/unreal/tags/categories',
    name: 'library-furniture-tag-categories',
    component: () => import('../Pages/Service/Furniture/index.vue'),
    meta: {
      name: 'Мебель — категории тегов',
      section: 'tagCategories',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/furniture/unreal/groups',
    name: 'library-furniture-groups',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Группы мебели',
      section: 'furnitureGroups',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/materials/objects',
    name: 'library-materials-objects',
    component: () => import('../Pages/Service/UnrealMaterials/index.vue'),
    meta: {
      name: 'Материалы — объекты',
      section: 'objects',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/materials/tags',
    name: 'library-materials-tags',
    component: () => import('../Pages/Service/UnrealMaterials/index.vue'),
    meta: {
      name: 'Материалы — теги',
      section: 'tags',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/apertures/objects',
    name: 'library-apertures-objects',
    component: () => import('../Pages/Service/Apertures/index.vue'),
    meta: {
      name: 'Апертуры — объекты',
      section: 'objects',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/apertures/tags',
    name: 'library-apertures-tags',
    component: () => import('../Pages/Service/Apertures/index.vue'),
    meta: {
      name: 'Апертуры — теги',
      section: 'tags',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/moldings/objects',
    name: 'library-moldings-objects',
    component: () => import('../Pages/Service/Moldings/index.vue'),
    meta: {
      name: 'Молдинги — объекты',
      section: 'objects',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/moldings/tags',
    name: 'library-moldings-tags',
    component: () => import('../Pages/Service/Moldings/index.vue'),
    meta: {
      name: 'Молдинги — теги',
      section: 'tags',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/styles/:id/objects/new',
    name: 'library-style-objects-create',
    component: () => import('../Pages/Service/Substances/StyleObjectVersionCreate.vue'),
    meta: {
      name: 'Новая версия рекомендуемых объектов',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/styles/:id/objects',
    name: 'library-style-objects',
    component: () => import('../Pages/Service/Substances/StyleObjectDefaults.vue'),
    meta: {
      name: 'Стиль',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/styles/:id',
    name: 'library-style',
    component: () => import('../Pages/Service/Substances/StyleObjectDefaults.vue'),
    meta: { name: 'Стиль' },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/styles/list',
    name: 'library-styles',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Стили',
      section: 'styles',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/styles/presets',
    name: 'library-presets',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Пресеты',
      section: 'presets',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/room-types',
    name: 'library-room-types',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Типы комнат',
      section: 'roomTypes',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/library/environments',
    name: 'library-environments',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Окружения',
      section: 'unrealEnvironment',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/quality/checklists',
    name: 'quality-checklists',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Чеклисты',
      section: 'checklists',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/quality/guards',
    name: 'quality-guards',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Проверки планировок',
      section: 'guards',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/quality/issue-categories',
    name: 'quality-issue-categories',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Категории замечаний',
      section: 'issueCategories',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/integrations/brandings',
    name: 'integrations-brandings',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Брендинги',
      section: 'brandings',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/integrations/webhooks',
    name: 'integrations-webhooks',
    component: () => import('../Pages/Service/Substances/index.vue'),
    meta: {
      name: 'Вебхуки',
      section: 'webhooks',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/users/list',
    name: 'users-list',
    component: () => import('../Pages/Service/Users/index.vue'),
    meta: {
      name: 'Пользователи',
      section: 'list',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/users/register',
    name: 'users-register',
    component: () => import('../Pages/Service/Users/index.vue'),
    meta: {
      name: 'Регистрация пользователей',
      section: 'register',
    },
    beforeEnter: PermissionMiddleware,
  },
  { path: '/substances', redirect: '/library/styles/list' },
  { path: '/furniture', redirect: '/library/furniture/unreal/objects' },
  { path: '/materials', redirect: '/library/materials/objects' },
  { path: '/apertures', redirect: '/library/apertures/objects' },
  { path: '/moldings', redirect: '/library/moldings/objects' },
  { path: '/svg-editor/icons', redirect: '/library/furniture/svg' },
  { path: '/users', redirect: '/users/list' },
  { path: '/users/archived', redirect: '/users/list' },

  {
    path: '/error',
    name: 'ErrorPage',
    component: () => import('../Pages/ErrorPage.vue'),
    meta: {
      name: 'Ошибка сервера',
    },
  },
  {
    path: '/mattermost/callback',
    name: 'MattermostCallback',
    component: () => import('../Pages/MattermostCallback.vue'),
    meta: {
      name: 'Привязка Mattermost',
    },
  },

  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../Pages/Profile.vue'),
    meta: {
      name: 'Профиль',
    },
    beforeEnter: PermissionMiddleware,
  },
];

serviceRoutes.forEach((route) => {
  if (pagePermissions[route.name]) route.meta.permission = pagePermissions[route.name];
});

export { serviceRoutes };
